export default __webpack_public_path__ + "static/amml_logo-52c30b81c303c2b2053f73b1699ca657.svg";